import styled from 'styled-components';

export const PortalSpinnerContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  background: ${({ theme }) => theme?.colors?.background};
  height: 100vh;
  max-width: 100vw;
  width: 100%;
  display: grid;
  text-align: center;
  place-items: center;

  .logo-container-context-text {
    text-align: center;
    margin: 24px;
    margin-top: 16px;
    font-size: 1rem;
    opacity: 0.8;
    max-width: 180px;
    color: var(--primary-color);
  }

  .breathing-img img,
  .breathing-img svg {
    max-width: 180px;
    max-height: 100px;
    -webkit-animation: breathing 1s ease-out infinite normal;
    animation: breathing 1s ease-out infinite normal;
    -webkit-font-smoothing: antialiased;
  }

  @-webkit-keyframes breathing {
    0% {
      -webkit-transform: scale(0.9);
      transform: scale(0.9);
    }

    50% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }

    100% {
      -webkit-transform: scale(0.9);
      transform: scale(0.9);
    }
  }

  @keyframes breathing {
    0% {
      -webkit-transform: scale(0.9);
      -ms-transform: scale(0.9);
      transform: scale(0.9);
    }

    50% {
      -webkit-transform: scale(1);
      -ms-transform: scale(1);
      transform: scale(1);
    }

    100% {
      -webkit-transform: scale(0.9);
      -ms-transform: scale(0.9);
      transform: scale(0.9);
    }
  }
`;
